export default __webpack_public_path__ + "static/media/icon_zone_control_3.214ca946.png";